import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../app/store";
import { postForgotPassword } from "../authentificationSlice";
import { InitPasswordReset } from "../authModel";
import { GetServerEmailError } from "../../../app/validation";
import { useEmailErrorMessage } from "../../../UIComponents/Form/EmailField";
import { LoadingPage } from "../../CommonPages/loadingPage";
import ForgotPasswordCard from "./forgotPasswordCard";
import { Dialog } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import SuccessCard from "../../CommonPages/successCard";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState<string | undefined>();
  const forgotPasswordData = useSelector((state: RootState) => state.AuthentificationSlice);
  const { t } = useTranslation();
  const getEmailError = useEmailErrorMessage();
  const dispatch = useDispatch<AppDispatch>();
  const [openDialog, setOpenDialog] = useState(false);
  const [success, setSuccess] = useState(false);
  const [messsage, setMesssage] = useState('');

  const handleOpenDialog = () => setOpenDialog(!openDialog);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    submitFunction(email);
  };

  const submitFunction = (email: string) => {
    const emailProblem = getEmailError(email);
    if (emailProblem) {
      setEmailError(emailProblem);
      return;
    }
    const forgotPassReq: InitPasswordReset = { username: email };
    dispatch(postForgotPassword(forgotPassReq))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (forgotPasswordData.statusCode === '200' || forgotPasswordData.statusCode === 'OK') {
      setSuccess(true);
      setMesssage(t("RequestForPasswordResetWasSentCheckYourEmail"));
      handleOpenDialog();
    }
    else if (forgotPasswordData.statusCode === '404') {
      setSuccess(false);
      setMesssage(t("UserDoesNotExist"));
      handleOpenDialog();
    }
    else if (forgotPasswordData.statusCode !== '') {
      // A 400 on the email is a fixable typo, so it goes on the field.
      const serverEmailError = GetServerEmailError(forgotPasswordData.statusCode, forgotPasswordData.error);
      if (serverEmailError) {
        setEmailError(serverEmailError);
        return;
      }
      setSuccess(false);
      setMesssage(forgotPasswordData.error ?? t("AnErrorOccurred"));
      handleOpenDialog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forgotPasswordData.statusCode])

  if (forgotPasswordData.isLoading === true) {
    return (LoadingPage(forgotPasswordData.isLoading))
  }

  return (
    <div className="flex justify-center m-[5%]">
      <form className="space-y-5" onSubmit={handleSubmit}>
        <ForgotPasswordCard onClickFunction={submitFunction} setEmailForm={setEmail} emailError={emailError} onEmailErrorClear={() => setEmailError(undefined)} />
        <input type="submit" style={{ display: "none" }} />
      </form>
      <Dialog open={openDialog} handler={handleOpenDialog} size="xs" animate={{ mount: { scale: 1, y: 0 }, unmount: { scale: 0.9, y: -100 } }}>
        <SuccessCard onClickFunction={handleOpenDialog} text={messsage} success={success} />
      </Dialog>
    </div>
  );
}
